/** UUID klienta commerce — nie identyfikator konfiguracji creative (CRE-*). */
const isValidCommerceCustomerId = (id: string | undefined | null): id is string => {
  const trimmed = id?.trim();
  return Boolean(trimmed && !trimmed.startsWith('CRE-'));
};
export default isValidCommerceCustomerId;